import $ from 'jquery';
import Swiper, {
	Navigation,
	Pagination,
	EffectFade,
	Mousewheel,
	Lazy,
	Autoplay,
} from 'swiper/core';
import LazyLoad from 'vanilla-lazyload';

Swiper.use([Navigation, Pagination, EffectFade, Mousewheel, Lazy, Autoplay]);

class BraggCarousel {
	constructor(el, settings) {
		this.container = el;
		this.settings = settings;
		this.init();
	}

	init() {
		var lazyImg = new LazyLoad({
				elements_selector: '.swiper-slider img',
			}),
			defaultSettings = {
				watchSlidesVisibility: true,
				resizeObserver: true,
				observer: true,
				observeSlideChildren: true,
				lazy: {
					loadPrevNext: true,
					elementClass: 'swiper-lazy:not(.lazy)',
				},
				on: {
					afterInit: function () {
						lazyImg.loadAll();
						lazyImg.update();
					},
				},
			},
			getSettings = this.settings,
			fullSettings = Object.assign(defaultSettings, getSettings);

		var carousel = new Swiper(this.container, fullSettings);
	}
}
export default BraggCarousel;
